import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import {
  MatPaginatorModule,
  PageEvent,
  MatPaginatorIntl
} from '@angular/material/paginator';

import { Translate } from '../../utils/translate';
import {
  Authorizations,
  AuthorizationType
} from '../../model/authorization.model';
import {
  TransfersListResponse,
  JudgementsListResponse,
  RedPlatesListResponse,
  RequestListResponse
} from '../../model/request-list.model';
import {
  RequestType,
  RequestTypeTranslation
} from '../../model/requestType.enum';
import { ProjectType } from '../../model/projectType.enum';

import { OrderService } from 'src/app/core/services/order.service';

import { FeedbackModalComponent } from '../feedback-modal/feedback-modal.component';
import { ModalRequestAppraisalComponent } from 'src/app/views/modal-request-appraisal/modal-request-appraisal.component';
import { CancelWithReasonModalComponent } from '../cancel-with-reason-modal/cancel-with-reason-modal.component';
import { ModalModifyBookVehicleComponent } from 'src/app/views/modal-modify-book-vehicle/modal-modify-book-vehicle.component';
import { ModalExtendTransferComponent } from 'src/app/views/modal-extend-transfer/modal-extend-transfer.component';
import { RequestStatus } from '../../model/requestStatus.enum';
import { StorageService } from 'src/app/core/storage/storage.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  standalone: true,
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    ReactiveFormsModule,
    MatCardModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatDialogModule,
    MatTooltipModule
  ]
})
export class ListItemComponent implements OnInit, OnChanges {
  @HostBinding('class') css: string | undefined = undefined;

  @Input()
  data:
    | RequestListResponse[]
    | JudgementsListResponse[]
    | TransfersListResponse[]
    | RedPlatesListResponse[]
    | Authorizations[] = [];
  @Input() allSelected?: boolean;
  @Input() type!: string;
  @Input() requestType!: string;
  @Input() authorizationType!: string;
  @Input() dataPagination: any = {
    totalResults: 0,
    results: 0,
    page: 1
  };
  @Input() state?: string;
  @Input() status?: string;

  @Output() authorizationsListEmitter = new EventEmitter<any>();
  @Output() allSelectedChangeEmitter = new EventEmitter<boolean>();
  @Output() uncheckCheckboxEmitter = new EventEmitter<boolean>();
  @Output() pageEmitter = new EventEmitter<number>();
  @Output() updateListEmitter = new EventEmitter<any>();

  list: any = [];

  authorizationsList?: RequestListResponse[] | Authorizations[] = [];
  requestTypeTranslation = Object.values(RequestTypeTranslation);
  showModal = false;

  length = 100;
  pageSize = 5;
  pageIndex = 0;
  hidePageSize = false;
  pageEvent!: PageEvent;
  requestTypeTr = RequestTypeTranslation;
  requestTypeMayus = RequestType;
  requestTypeEnum = AuthorizationType;
  projectTypeEnum = ProjectType;
  authorizationEnum = AuthorizationType;
  requestStatusEnum = RequestStatus;

  pendingPlate = i18next.t('pendingPlate');
  pendingData = i18next.t('authStatusPending');
  pendingModel = i18next.t('pendingModel');
  noData = i18next.t('noData');
  landing2 = false;

  constructor(
    public translate: Translate,
    private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private orderService: OrderService,
    public paginator: MatPaginatorIntl,
    private storageService: StorageService
  ) {
    this.paginator.nextPageLabel = i18next.t('next');
    this.paginator.previousPageLabel = i18next.t('prev');
  }

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.css = this.landing2 ? 'landing2' : undefined;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['data']) {
      this.list = this.data;
      if (this.list?.length > 0 && this.type === 'vehicles') {
        if (this.requestType === 'requests') {
          this.paginator.itemsPerPageLabel = i18next.t('requestPerPage');
        } else if (this.requestType === 'judgements') {
          this.paginator.itemsPerPageLabel = i18next.t('judgementsPerPage');
        } else if (this.requestType === 'red-plates') {
          this.paginator.itemsPerPageLabel = i18next.t('redplatesPerPage');
        } else if (this.requestType === 'es') {
          this.paginator.itemsPerPageLabel = i18next.t('esPerPage');
        } else {
          this.paginator.itemsPerPageLabel = i18next.t('transfersPerPage');
        }
      } else {
        if (this.list) {
          for (const item of this.list) {
            item.statusTranslation = item.status
              ? this.translate.translateAuthorizationsStatus(item.status)
              : i18next.t('noData');
            item.checked = false;
          }
          this.resetChecksList(false);
        }
        this.paginator.itemsPerPageLabel = i18next.t('AuthPerPage');
      }
    }
    if (!!changes['allSelected']) {
      const valueAllSelected = changes['allSelected'].currentValue;
      if (
        valueAllSelected ||
        (!valueAllSelected &&
          this.list.every(
            (authorization: Authorizations) => authorization.checked
          ))
      ) {
        for (const item of this.list) {
          item.checked = changes['allSelected'].currentValue;
        }
      }

      this.list = this.list;
    }
  }

  form: FormGroup = this.fb.group({
    authorization: [false]
  });

  updateAuthorizationsList(event: any) {
    const authorizationList = this.list as Authorizations[];

    const authorization = authorizationList.find((authorization) => {
      if (authorization.requestNumber) {
        return (
          authorization.requestNumber === event.source?.value?.requestNumber
        );
      } else if (authorization.id) {
        return authorization.id === event.source?.value?.id;
      } else {
        return authorization.redPlateId === event.source?.value?.redPlateId;
      }
    });

    if (!!authorization) {
      authorization.checked = event.checked;
    }

    if (
      authorizationList.every(
        (authorization: Authorizations) => authorization.checked
      )
    ) {
      this.allSelectedChangeEmitter.emit(true);
    } else {
      this.allSelectedChangeEmitter.emit(false);
    }
  }

  resetChecksList(checked: boolean) {
    this.form.get('authorization')?.patchValue(checked);
  }

  seeDetail(requestNumber: string, requestType: string) {
    if (requestType === this.requestTypeMayus.proyect) {
      this.router.navigate(['/detail-request', requestNumber], {
        queryParams: { type: 'PROJECT' }
      });
    } else {
      this.router.navigate(['/detail-request', requestNumber]);
    }
  }

  modifyDetail(requestNumber: string, requestType: string) {
    if (requestType === this.requestTypeMayus.proyect) {
      this.router.navigate(['/detail-request', requestNumber], {
        queryParams: { mode: 'modify', type: 'PROJECT' }
      });
    } else {
      this.router.navigate(['/detail-request', requestNumber], {
        queryParams: { mode: 'modify' }
      });
    }
  }

  openCancelModal(requestNumber: string): void {
    const dialogRef = this.dialog.open(FeedbackModalComponent, {
      data: {
        cancelOrder: true,
        text: i18next.t('cancelModal'),
        theme: 'dark'
      }
    });

    dialogRef.componentInstance.confirmCancelOrderEmitter.subscribe(() => {
      if (requestNumber) {
        this.cancelRequest(requestNumber, null);
      }
    });
  }

  openCancelModalBook(requestNumber: string): void {
    const dialogRef = this.dialog.open(FeedbackModalComponent, {
      data: {
        cancelOrder: true,
        text: i18next.t('cancelBookVehicle'),
        theme: 'dark'
      }
    });

    dialogRef.componentInstance.confirmCancelOrderEmitter.subscribe(() => {
      if (requestNumber) {
        this.cancelBookVehicle(requestNumber);
      }
    });
  }

  openCancelModalProjectRegu(requestNumber: string): void {
    const dialogRef = this.dialog.open(CancelWithReasonModalComponent, {
      data: {
        text: i18next.t('cancelRegularizationTitle')
      }
    });

    dialogRef.componentInstance.confirmCancelOrderEmitter.subscribe(
      (reasonValue: string) => {
        if (requestNumber) {
          this.cancelRequest(requestNumber, reasonValue);
        }
      }
    );
  }

  openCancelJudgementModal(requestNumber: string): void {
    const dialogRef = this.dialog.open(CancelWithReasonModalComponent, {
      data: {
        text: i18next.t('cancelJudgement')
      }
    });

    dialogRef.componentInstance.confirmCancelOrderEmitter.subscribe(
      (reasonValue: string) => {
        if (requestNumber) {
          this.cancelJudgementRequest(requestNumber, reasonValue);
        }
      }
    );
  }

  cancelRequest(requestNumber: string, reasonValue: string | null): void {
    this.orderService.cancelRequest(requestNumber, reasonValue).subscribe({
      next: () => {
        this.list = this.list.filter(
          (req: RequestListResponse) => requestNumber !== req.requestNumber
        );
      },
      error: () => {
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('errorCancel'),
            close: true,
            theme: 'dark'
          }
        });
      }
    });
  }

  cancelJudgementRequest(requestNumber: string, reasonValue: string): void {
    this.orderService
      .cancelJudgementRequest(requestNumber, reasonValue)
      .subscribe({
        next: () => {
          this.list = this.list.filter((req: any) => requestNumber !== req.id);
        },
        error: () => {
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('errorCancel'),
              close: true,
              theme: 'dark'
            }
          });
        }
      });
  }

  cancelBookVehicle(requestNumber: string): void {
    this.orderService.cancelBookVehicle(requestNumber).subscribe({
      next: () => {
        this.updateListEmitter.emit();
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('cancelBookOK'),
            close: true,
            theme: 'dark'
          }
        });
      },
      error: () => {
        this.dialog.open(FeedbackModalComponent, {
          data: {
            text: i18next.t('cancelBookKO'),
            close: true,
            theme: 'dark'
          }
        });
      }
    });
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.pageEmitter.emit(e.pageIndex);
  }

  reloadPage(): void {
    window.location.reload();
  }

  redirectToBookVehicle(requestNumber: string) {
    this.router.navigate(['/book-vehicle', requestNumber]);
  }

  requestAppraisal(requestNumber: string): void {
    const dialogRef = this.dialog.open(ModalRequestAppraisalComponent, {
      data: requestNumber
    });

    dialogRef.componentInstance.confirmAppraisalEmitter.subscribe((reqNum) => {
      if (reqNum) {
        this.list.find(
          (req: RequestListResponse) => reqNum === req.requestNumber
        ).appraisalRequested = true;
      }
    });
  }

  extendTransfer(vin: string, deliveryDate: string, returnDate: string): void {
    this.dialog.open(ModalExtendTransferComponent, {
      data: { vin, deliveryDate, returnDate }
    });
  }

  modifyBookVehicle(content: any): void {
    const dialogRef = this.dialog.open(ModalModifyBookVehicleComponent, {
      data: content
    });

    dialogRef.afterClosed().subscribe(() => {
      this.updateListEmitter.emit();
    });
  }

  tooltipTransfer(department: any): string {
    const tooltipText = `${i18next.t('departament')}: ${department.name ? department.name : i18next.t('noData')}\n\nCP: ${department.costCenter ? department.costCenter : i18next.t('noData')}`;
    return tooltipText;
  }
}
